import React, { ReactNode } from 'react';
import { ColorType, Label, LabelType } from '../_ui';
import { TimezoneMessage } from './TimezoneMessage.component';

interface LicenseDetailLabelPairProps {
  label: string;
  showTimezoneMsg?: boolean;
  value: string | number | ReactNode;
  height?: string;
  alignItems?: string;
  valueClassName?: string;
}

const LicenseDetailLabelPair = React.memo(
  ({
    label,
    showTimezoneMsg,
    value,
    height = 'h-10',
    alignItems = 'items-center',
    valueClassName = '',
  }: LicenseDetailLabelPairProps) => {
    return (
      <div className={`flex flex-row ${height} ${alignItems} py-2.5`}>
        <div className='flex flex-col basis-2/6'>
          <Label text={label} type={LabelType.LABEL_S} color={ColorType.GREY6} />
          {showTimezoneMsg && (
            <div className='mt-4 mb-5'>
              <TimezoneMessage />
            </div>
          )}
        </div>

        {typeof value === 'string' || typeof value === 'number' ? (
          <Label
            text={value}
            type={LabelType.BODY3}
            color={ColorType.BLACK}
            className={`pl-3 ${valueClassName}`}
          />
        ) : (
          <div className={`pl-3 ${valueClassName}`}>{value}</div>
        )}
      </div>
    );
  },
);

LicenseDetailLabelPair.displayName = 'LicenseDetailLabelPair';

export default LicenseDetailLabelPair;
